
import { useState, useContext } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { FaBell } from 'react-icons/fa';

import './header.css';
import { UserContext } from '../context/user-context';

export default function Header () {
  const { userToken, user } = useContext(UserContext);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const onToggleNotifications = () => {
    setShowNotifications(!showNotifications);
    if (notifications.length == 0) {
      getNotifications();
    }
  }

  const getNotifications = async() => {
    const time = new Date().getTime();
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/wp-json/gigfiliate/v1/affiliates/${user?.ID}/notifications?timestamp=${time}`, {
      headers: {
        'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
        'Content-Type': 'multipart/form-data'
      },
    });
    if (res.data.notifications) {
      setNotifications(res.data.notifications);
    }
  }

  function timeAgo(dateString) {
    const now = new Date();
    const date = new Date(dateString);
    // Calculate the difference in milliseconds
    const diffMs = now - date;
    const diffSecs = Math.round(diffMs / 1000);
    const diffMins = Math.round(diffSecs / 60);
    const diffHours = Math.round(diffMins / 60);
    const diffDays = Math.round(diffHours / 24);
    if (diffMins < 1) {
      return 'Now';
      // return `${diffSecs}s ago`;
    } else if (diffHours < 1) {
      return `${diffMins}m`;
    } else if (diffDays < 1) {
      return `${diffHours}hr`;
    } else {
      const days = Math.floor(diffDays);
      const remainingHours = diffHours % 24;
      if (remainingHours > 0) {
        return `${days}d ${remainingHours}hr`;
      } else {
        return `${days}d`;
      }
    }
  }

  return (
    <header className="main-header text-center bg-black text-white py-3">
      <Container style={{ position: 'relative' }}>
        <Row>
          <Col className={`d-flex justify-content-${!userToken ? 'center' : 'start'}`}>
            <Link to="/">
              <img src="https://gnetworkclub.com/wp-content/themes/gatsbyoc/assets/img/GNetwork-Text-Logo_White.svg" alt="GNetwork" className="header-logo"/>
            </Link>
          </Col>
          {(user) && (
            <Col className="header_account-container">
              <Link to="/account" className="header_account-container-link text-glow-orange">
                {user.display_name}
                <img className="header-avatar" src={user.image} alt={user.display_name} />
              </Link>
              <span style={{ cursor: 'pointer' }}>
                <FaBell onClick={onToggleNotifications}/>
              </span>
            </Col>
          )}
        </Row>
        {showNotifications && (
          <div className="notifications-container">
            <div className="notifications-container_top-caret"></div>
            <div className="notifications-container_content">
              <h4 className="fs-1x">Notifications</h4>
              <hr/>
              {notifications.length > 0 && (
                <ul className="notifications-list">
                  {notifications.map((notification) => {
                    return (
                      <li key={notification.id} className={`${(notification.read_at ? 'notif-read' : '')}`}>
                        <span>{notification.content}</span> ◦ <time datetime={notification.created_at}>{timeAgo(notification.created_at)}</time>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        )}
      </Container>
    </header>
  )
}